import { Heading } from '@heathmont/moon-core';
import { rem } from '@heathmont/moon-utils';
import styled from 'styled-components';
import media from '~/client/shared/media';

const Preview = styled(Heading)`
  display: none;
  ${media.tabletMedium} {
    display: block;
    overflow: hidden;
    max-height: ${rem(56)};
    margin-top: 0;
    margin-bottom: ${rem(12)};
    opacity: 0.5;
  }
  p {
    margin-top: 0;
  }
`;

export default Preview;
